// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1t7TO","row":"Node_row__2oJIp","label":"Node_label__3W0_T","footer":"Node_footer__2pHCR"};